import type { TMe } from '@/src/features/auth/models/auth.types'
import type { TFraternityOnboarding } from '@/src/features/fraternity/api/fraternityApi.types'
import { withFraternity } from '@/src/features/fraternity/utils/withFraternity'

import type { TFullCommunityApi } from '../api/communityApi.types'
import { COMMUNITY_ACTIVITY, COMMUNITY_LIFETIME } from '../models/community.constants'
import { FRATERNITY_QUESTION_STEPS, type TJoinStep } from '../models/joinSteps.types'

type TBuildJoinStepsParams = {
  community?: Pick<TFullCommunityApi, 'activity' | 'lifetime' | 'tags'>
  me?: Pick<TMe, 'behavioralSegment'>
  isPushGranted?: boolean
  onboarding?: Pick<TFraternityOnboarding, 'has_asked_fraternity'> | null
}

export const buildJoinSteps = ({
  community,
  me,
  isPushGranted = false,
  onboarding,
}: TBuildJoinStepsParams): TJoinStep[] => {
  const steps: TJoinStep[] = []

  if (withFraternity(community)) {
    if (!isPushGranted) {
      steps.push('push')
    }
    steps.push('ready', 'presentation', 'fraternity')
    if (onboarding?.has_asked_fraternity !== false) {
      steps.push(...FRATERNITY_QUESTION_STEPS)
    }
  } else {
    if (
      community?.activity !== COMMUNITY_ACTIVITY.COMING_SOON &&
      community?.lifetime !== COMMUNITY_LIFETIME.EVERLASTING
    ) {
      steps.push('date')
    }
    steps.push('push')
    if (me?.behavioralSegment === 'core-active' || me?.behavioralSegment === 'site-consultation') {
      steps.push('email')
    }
  }

  return steps
}
